import Service from "../Service";
const resource = "equipmentmaintenance/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    listGetSupportStaff(parameters, requestID) {
        return Service.post(resource + 'listGetSupportStaff', parameters, {
            params: { requestID: requestID }
        })
    },
    getMaintenanceByID(temID, requestID) {
        return Service.get(resource + 'getMaintenanceByID', {
            params: {
                TemID: temID,
                requestID: requestID
            }
        })
    },
    deleteMaintenanceByID(temID, requestID) {
        return Service.delete(resource + 'deleteMaintenanceByID', {
            params: {
                TemID: temID,
                requestID: requestID
            }
        })
    },

    TicEquipmentMaintenanceGroupDetail(emgID, requestID) {
        return Service.get(resource + 'TicEquipmentMaintenanceGroupDetail', {
            params: {
                EmgID: emgID,
                requestID: requestID
            }
        })
    },
    ReprogramList(emgID, requestID) {
        return Service.get(resource + 'ReprogramList', {
            params: {
                EmgID: emgID,
                requestID: requestID
            }
        })
    }
};
